exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p[data-v-ca3761ea]{font-size:15px;text-align:justify}img[data-v-ca3761ea]{position:relative;clear:both;width:100%;height:100%}p[data-v-ca3761ea]{color:#fff}", ""]);

// exports
